import React from 'react';
import styled from 'styled-components';

const RadioButtonContainer = styled.div`
  width: 17px;
  min-width: 17px;
  min-height: 17px;
  height: 17px;
  background-color: white;
  border: 1px solid ${(props) => props.theme.colors['grey-two']};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &:hover {
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  }
`;

const RadioButtonChecked = styled.div`
  min-width: 10px;
  height: 10px;
  position: absolute;
  border-radius: 50px;
  background-color: ${(props) => props.theme.colors['terra-cotta']};
`;

const RadioButtonLabel = styled.p`
  font-size: 12px;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  margin-left: 10px;
  color: ${(props) =>
    props.disabled ? '#b7bbbf' : props.theme.colors['dark-three']};
`;

const RadioButtonLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  :not(:last-child) {
    margin-right: 14px;
  }
`;

const Label = styled.p`
  font-size: 12px;
  margin-bottom: 17.5px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors['dark']};
  font-family: ${(props) => props.theme.fonts.oswald};
`;

const RadioButtonGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const RadioButtons = ({
  label,
  radioButtons,
  disabled,
  onChange,
  returnValue
}) =>
  radioButtons && radioButtons.length > 0 ? (
    <div>
      {label && <Label>{label}</Label>}
      <RadioButtonGroupContainer>
        {radioButtons.map((button, index) => (
          <RadioButtonLabelContainer key={`radioButton-${index}`}>
            <RadioButtonContainer
              disabled={disabled}
              onClick={
                disabled
                  ? null
                  : () => onChange(returnValue ? button.value : button.label)
              }
            >
              {button.checked && <RadioButtonChecked />}
            </RadioButtonContainer>
            <RadioButtonLabel disabled={disabled}>
              {button.label}
            </RadioButtonLabel>
          </RadioButtonLabelContainer>
        ))}
      </RadioButtonGroupContainer>
    </div>
  ) : null;

export default RadioButtons;
